import { createBrowserRouter } from "react-router-dom";

import { ExternalPageLayout } from "AdvisoryManagement/Components/Layouts/ExternalPageLayout";
import AdvisoryManagementPage from "AdvisoryManagement/Pages/AdvisoryManagementPage";
import { ElisPage } from "AdvisoryManagement/Pages/ElisPage";
import { ExtranetyPage } from "AdvisoryManagement/Pages/ExtranetyPage";
import { FinamPage } from "AdvisoryManagement/Pages/FinamPage";
import { InvestmentQuestionnairePage } from "AdvisoryManagement/Pages/InvestmentQuestionnairePage";
import { ZzjPage } from "AdvisoryManagement/Pages/ZzjPage";
import { AuthCallbackPage } from "Auth/Pages/AuthCallbackPage";
import { AuthLogoutCallbackPage } from "Auth/Pages/AuthLogoutCallbackPage";
import { SignInPage } from "Auth/Pages/SignInPage";
import { HomePage } from "Home/Pages/HomePage";
import { Error403Page } from "Infrastructure/Pages/Error403Page";
import { Error404Page } from "Infrastructure/Pages/Error404Page";
import { AuthenticatedRoute } from "Infrastructure/Routing/AuthenticatedRoute";
import { UnauthenticatedRoute } from "Infrastructure/Routing/UnauthenticatedRoute";
import { AppRouting, getRoute } from "Infrastructure/Utils/UrlUtils";

const appRoutes = [
	{
		path: getRoute(AppRouting.Home),
		element: (
			<AuthenticatedRoute>
				<HomePage />
			</AuthenticatedRoute>
		),
	},
	{
		path: getRoute(AppRouting.SignIn),
		element: (
			<UnauthenticatedRoute>
				<SignInPage />
			</UnauthenticatedRoute>
		),
	},
	{
		path: getRoute(AppRouting.AdvisoryCase),
		element: (
			<AuthenticatedRoute>
				<AdvisoryManagementPage />
			</AuthenticatedRoute>
		),
	},
	{
		path: getRoute(AppRouting.External.Finam),
		element: (
			<ExternalPageLayout>
				<FinamPage />
			</ExternalPageLayout>
		),
	},
	{
		path: getRoute(AppRouting.External.Elis),
		element: (
			<ExternalPageLayout>
				<ElisPage />
			</ExternalPageLayout>
		),
	},
	{
		path: getRoute(AppRouting.External.Extranety),
		element: (
			<ExternalPageLayout>
				<ExtranetyPage />
			</ExternalPageLayout>
		),
	},
	{
		path: getRoute(AppRouting.External.Zzj),
		element: (
			<ExternalPageLayout>
				<ZzjPage />
			</ExternalPageLayout>
		),
	},
	{
		path: getRoute(AppRouting.External.InvestmentQuestionnaire),
		element: (
			<ExternalPageLayout>
				<InvestmentQuestionnairePage />
			</ExternalPageLayout>
		),
	},
	{
		path: getRoute(AppRouting.AuthCallback),
		element: <AuthCallbackPage />,
	},
	{
		path: getRoute(AppRouting.AuthLogoutCallback),
		element: <AuthLogoutCallbackPage />,
	},
	{
		path: getRoute(AppRouting.Error403),
		element: <Error403Page />,
	},
	{
		path: "*",
		element: <Error404Page />,
	},
];

export const appRouter = createBrowserRouter(appRoutes, {
	basename: import.meta.env.VITE_BASE_URL,
});
